// ImageWithLoader.jsx
import React, { useState } from 'react';
import CircularProgress from '@mui/joy/CircularProgress'; // 사용중인 컴포넌트 라이브러리에 맞게 import

function ImageWithLoader({ src, onClick, style } : any) {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {/* 로딩 중이면 중앙에 스피너 표시 */}
      {isLoading && (
        <div
          style={{
            width : "100%",
            height : "120px",
            display : "flex",
            justifyContent : "center",
            alignItems : "center",
          }}
        >
          <CircularProgress size="sm" />
        </div>
      )}

      {/* 실제 이미지 */}
      <img
        src={src}
        alt={'media'}
        onLoad={handleLoad}
        onError={handleError}
        onClick={onClick}
        style={{
          // 로딩 중엔 숨기기 / 로딩 끝나면 보이기
          display: isLoading ? 'none' : 'block',
          ...style,
        }}
      />
    </div>
  );
}

export default ImageWithLoader;